import React from 'react';
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import TypeChilds from '../Types/SpecificType';
import TypeForm from './TypeForm';
import swal from 'sweetalert';
import $ from 'jquery';
import { ButtonGroup } from 'react-bootstrap';


class ListForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allTypes: [],
            showChidComponent: false,
            selectedid: ''
        }
    }


    onChangeInput = (e) => {
        e.preventDefault();
        // this.checkRequirement(e.target.name, e.target.value);
        this.setState({ [e.target.name]: e.target.value })
    }
    handleSubmit = () => {



    }
    componentDidMount() {
        /* -----  Tooltip ----- */
        $('[data-toggle="tooltip"]').tooltip();
        this.getTotalLike()
    }
    getTotalLike = () => {
        var data = {
            jwt: jwt,
            s_id: ud.main_id
        }
        var _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/view/parenttypes`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    _this.setState({ allTypes: response.data.result })
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalLike();
                        }
                    })
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong,Please Retry")
            });
    }
    clickedType = (id) => {
        this.setState({ showChidComponent: true, selectedid: id })
    }
    createParentOpen = () => {
        this.setState({ openCreateParent: true, selectedParent: 0, iseditmode: false })
    }
    updateTypeForm = () => {
        this.setState({ openCreateParent: false })
        this.getTotalLike()
    }
    render() {

        return (
            <div>
                <div className="xp-breadcrumbbar">
                    <div className="row">
                        <div className="col-md-6 col-lg-6">
                            <h4 className="xp-page-title">Create Structure</h4>
                        </div>
                        <div className="col-md-6 col-lg-6">
                            <div className="xp-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i className="icon-home"></i></a></li>
                                    {/* <li className="breadcrumb-item active" aria-current="page">Create Structure</li> */}
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="xp-contentbar">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card m-b-30">
                                <div class="card-body">
                                    <div class="form-group">
                                        {/* <div class="col-md-12 col-lg-8 col-xl-8 align-self-center"> */}
                                        <div class="card bg-white m-b-30">
                                            <div class="card-header bg-white dv-center space-between">

                                                <button className="btn btn-primary btn-lg" title="Create Structure" onClick={this.createParentOpen}><i className="mdi mdi-plus mr-2"></i>Create Structure</button>
                                            </div>
                                            <div class="card-body">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center" style={{ width: "5rem" }}>S.No.</th>
                                                                <th class="text-left">Type Name</th>
                                                                <th class="text-center">Creation Date</th>
                                                                <th className="text-center">Action</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.allTypes.map((list, index) => <tr onClick={() => this.clickedType(list.id)}>
                                                                <td className="text-center"><strong>{index + 1}.</strong></td>
                                                                <td class="text-left">
                                                                    <a>{list.name}</a>
                                                                </td>
                                                                <td class="text-center">{new Date(list.creationdate).toUTCString()}</td>
                                                                <td className="text-center">
                                                                    <ButtonGroup>
                                                                        <button type="button" className="btn btn-info" data-toggle="tooltip" title="Preview"><i className="mdi mdi-eye"></i></button>
                                                                        {/* <button type="button" className="btn btn-light" data-toggle="tooltip" title="Edit"><i className="mdi mdi-pencil"></i></button> */}
                                                                        {/* <button type="button" className="btn btn-danger" data-toggle="tooltip" title="Delete"><i className="mdi mdi-trash-can-outline"></i></button> */}
                                                                    </ButtonGroup>
                                                                </td>
                                                            </tr>)}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* </div> */}
                                            </div>
                                            {this.state.showChidComponent ?
                                                <div id="popup" class="overlay">
                                                    <div class="modal-dialog modal-xl">
                                                        <div class="modal-content">
                                                            <div class="modal-header">
                                                                <h5 class="modal-title" id="exampleStandardModalLabel">Types</h5>
                                                                <button type="button" class="close" onClick={() => this.setState({ showChidComponent: false })}>
                                                                    <span aria-hidden="true">×</span>
                                                                </button>
                                                            </div>
                                                            <div class="modal-body">
                                                                <TypeChilds id={this.state.selectedid} />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* <div class="popup" style={{ width: "80%", margin: "auto" }}>
                                                        <div class="content">
                                                            <div className="card m-b-30" style={{ height: "100vh" }}>
                                                                <div className="card-header bg-white heading-cont">
                                                                    <h5 className="card-title text-black">Types</h5>
                                                                    <div onClick={() => this.setState({ showChidComponent: false })}>
                                                                        <svg class="bi bi-x-circle-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                            <path fill-rule="evenodd" d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z" clip-rule="evenodd" />
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                                <div className="card-body ">
                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}



                                                </div>
                                                : null}
                                            {this.state.openCreateParent ?
                                                <div id="popup" class="overlay">
                                                    <div class="modal-dialog">
                                                        <div class="modal-content">
                                                            <div class="modal-header">
                                                                <h5 class="modal-title" id="exampleStandardModalLabel">Types</h5>
                                                                <button type="button" class="close" onClick={() => this.setState({ openCreateParent: false })}>
                                                                    <span aria-hidden="true">×</span>
                                                                </button>
                                                            </div>
                                                            <div class="modal-body">
                                                                <TypeForm updateTypeForm={this.updateTypeForm} parent={this.state.selectedParent} iseditmode={this.state.iseditmode} selectednode={this.state.selectednode} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        )
    }
}
export default ListForm